module.exports = __webpack_public_path__ + "media/club_product_v2/settings-bbcc695a.webp";